<template>
  <div>
    <headline>
        Konferenzraum Statistik
        <template v-slot:more>
            <div class="flex justify-between">
            <t-datepicker
                :clearable="false"
                class="mr-2 mt-5"
                v-model="dateRange"
                userFormat="d.m.Y"
                range
            >
            </t-datepicker>
            <select-menu v-model="days"
                            :text='["Werktage (Mo-Fr)", "Berücksichtigung der Feiertage","Alle"]'
                            :values="['activeWorkingDays', 'generalWorkingDays','all']"
                            class="mr-2 mt-5">
                </select-menu>
            <floor-select v-model="floor" :filter="true"></floor-select>
            </div>
        </template>
    </headline>
    <full-card>
        <template v-slot:header>
            <div class="flex justify-center">Konferenzraum Buchungen vom {{ asDay(from) }} bis {{ asDay(to) }}</div>
        </template>
        <loading v-show="loading"></loading>
            <div v-show="!loading">
                            <div v-for="(value, key) in data" :key="key" class="flex justify-between items-center">
                <div class="py-1 mr-2 font-sans text-sm text-gray-500">
                    {{ asDay(key) }}
                </div>
                <div v-for="(capacity, time) in value" :key="time" class="flex-grow h-6 flex justify-center"
                    :class="{
                            'bg-green-50': 0 <= capacity && capacity < 20,
                            'bg-green-200': 20 <= capacity && capacity < 40,
                            'bg-green-400': 40 <= capacity && capacity < 60,
                            'bg-green-600': 60 <= capacity && capacity < 80,
                            'bg-green-900': 80 <= capacity && capacity <= 100,
                            }">
                </div>
            </div>
            <div class="flex justify-between ml-10">
                <div v-for="(timeStamp) in time" :key="timeStamp" class="flex-grow h-6 flex justify-center">
                    <div class="font-sans text-sm text-gray-500">
                        {{ timeStamp.slice(0,5) }}
                    </div>
                </div>
            </div>
            <div class="mt-10 flex justify-center items-center">
                <div class="font-bold text-lg">0 %</div>
                <img class="h-6 rounded-lg mx-4" src="/files/statisticColorScheme.png" alt="">
                <div class="font-bold text-lg">100 %</div>
            </div>
        </div>
    </full-card>
    <conference-room-hourly-statistic class="mt-16"></conference-room-hourly-statistic>
  </div>
</template>

<script>
import Headline from "../components/UI/Headline.vue"
import FullCard from "../components/UI/FullCard";
import ChartBar from "../components/Chart/ChartBar";
import moment from "moment";
import format from "date-fns/format";
import ButtonSecondary from "../components/UI/ButtonSecondary";
import SelectMenu from "../components/UI/SelectMenu.vue";
import FloorSelect from '../components/FloorSelect.vue';
import Loading from "../components/UI/Loading.vue";
import ConferenceRoomHourlyStatistic from "../components/ConferenceRoomHourlyStatistic.vue";

export default {
     name: "ConferneceRoomsStatistic",

    components: {
        FullCard,
        ButtonSecondary,
        ChartBar,
        SelectMenu,
        Headline,
        FloorSelect,
        Loading,
        ConferenceRoomHourlyStatistic
    },


    data: () => ({
        loading: false,
        data: [],
        floor: null,
        days: "activeWorkingDays",
        date: new Date().toISOString().substring(0, 10),
        from: new Date((new Date).getFullYear(), (new Date).getMonth(), 1),
        to: new Date((new Date).getFullYear(), (new Date).getMonth()+1, 0),
        dateRange: [new Date((new Date).getFullYear(), (new Date).getMonth(), 1), new Date((new Date).getFullYear(), (new Date).getMonth()+1, 0)],
        time: '',
    }),

    mounted() {
            this.load();
    },

    watch: {
        dateRange(range){
            this.from = new Date(range[0]);
            this.to = new Date(range[1]);
        },
        to() {
          this.load();
        },
        days(){
          this.load();
        },
        floor(){
            this.load();
        }
    },

    computed: {
    },

    methods: {

        load() {
            this.loading = true;
            let params = {
                zone: '',
                days: this.days,
                floor: this.floor,
            }
            if(this.from && this.to){
                    params.from = this.from;
                    params.to = this.to;
                }else{
                    params.filter = this.filter
                    params.date = new Date();
                }
          this.$http.get('/admin/conference_rooms_statistic', {
               params
            }).then(result => {
                this.loading = false;
                this.data = result.data.schedules;
                this.time = result.data.time.slice(0, -1);
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })

        },
        asMonth(day) {
            return getMonth(day);
        },
        asDay(day) {
            return format(new Date(day), 'dd.MM.');

        },
    }

}
</script>

<style>

</style>